export const useActiveDesactiveSrollBody = (value) => {
    if (value === true) {
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.overflow = 'unset'
    }
}